import {
	ADMIN_EMAIL_APPROVAL_REQUEST_GET,
	ADMIN_EMAIL_APPROVAL_RESPONSE_GET_FAIL,
	ADMIN_EMAIL_APPROVAL_RESPONSE_GET_SUCCESS,
	ADMIN_EMAIL_APPROVAL_ADD_MODAL,
	ADMIN_EMAIL_APPROVAL_SELECTED,
	ADMIN_EMAIL_APPROVAL_REQUEST_POST,
	ADMIN_EMAIL_APPROVAL_RESPONSE_POST_FAIL,
	ADMIN_EMAIL_APPROVAL_REQUEST_PUT,
	ADMIN_EMAIL_APPROVAL_RESPONSE_PUT_FAIL,
	DELETE_ADMIN_EMAIL_APPROVAL_RESPONSE_SUCCESS,
	RESET_ADMIN_EMAIL_APPROVAL_DELETE,
	DELETE_ACTION_TRIGGERED,
	ADMIN_EMAIL_APPROVAL_REQUEST_PATCH,
	ADMIN_EMAIL_APPROVAL_RESPONSE_PATCH_FAIL,
	ADMIN_EMAIL_APPROVAL_EDIT_MODAL,
	SET_EMAIL_VALUE,
	SET_NEW_PASSWORD,
	SET_IS_SUPER_ADMIN_VALUE,
	ADMIN_EMAIL_APPROVAL_RESPONSE_PATCH_SUCCESS,
	ADD_ADMIN_EMAIL_APPROVAL_RESPONSE_SUCCESS,
} from '../constants/adminEmailApprovalConstants';

export const adminEmailApprovalSelectedReducer = (
	state = {
		adminEmailApprovalSelected: {},
		deleteActionTriggered: false,
	},
	action
) => {
	switch (action.type) {
		case ADMIN_EMAIL_APPROVAL_SELECTED:
			return {
				...state,
				adminEmailApprovalSelected: action.payload,
			};
		case DELETE_ACTION_TRIGGERED:
			return {
				...state,
				deleteActionTriggered: action.payload,
			};
		default:
			return state;
	}
};

export const emailListReducer = (state = { emails: {} }, action) => {
	switch (action.type) {
		case ADMIN_EMAIL_APPROVAL_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case ADMIN_EMAIL_APPROVAL_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				emails: action.payload,
			};
		case ADMIN_EMAIL_APPROVAL_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const adminEmailApprovalAddModalReducer = (
	state = {
		adminEmailApprovalAddModal: false,
	},
	action
) => {
	switch (action.type) {
		case ADMIN_EMAIL_APPROVAL_ADD_MODAL:
			return {
				...state,
				adminEmailApprovalAddModal: action.payload,
			};

		default:
			return state;
	}
};
export const adminEmailApprovalEditModalReducer = (
	state = {
		adminEmailApprovalEditModal: false,
		// voucherAddModalOnSave:false,
	},
	action
) => {
	switch (action.type) {
		case ADMIN_EMAIL_APPROVAL_EDIT_MODAL:
			return {
				...state,
				adminEmailApprovalEditModal: action.payload,
			};

		default:
			return state;
	}
};

export const adminEmailApprovalAddReducer = (
	state = { msg: null, error: null, data: [], loading: false },
	action
) => {
	switch (action.type) {
		case ADMIN_EMAIL_APPROVAL_REQUEST_POST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case ADMIN_EMAIL_APPROVAL_RESPONSE_POST_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case ADD_ADMIN_EMAIL_APPROVAL_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};

		default:
			return state;
	}
};

export const adminEmailApprovalDeleteReducer = (
	state = {
		successMessageOnDelete: null,
		deleteError: null,
		data: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case ADMIN_EMAIL_APPROVAL_REQUEST_PUT:
			return {
				...state,
				loading: true,
				deleteError: null,
			};
		case ADMIN_EMAIL_APPROVAL_RESPONSE_PUT_FAIL:
			return {
				...state,
				loading: false,
				deleteError: action.payload,
			};
		case DELETE_ADMIN_EMAIL_APPROVAL_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_ADMIN_EMAIL_APPROVAL_DELETE:
			return {
				...state,
				loading: false,
				successMessageOnDelete: null,
				deleteError: null,
				data: [],
			};

		default:
			return state;
	}
};

export const adminEmailApprovalEditReducer = (
	state = { msg: null, error: null, data: [], loading: false },
	action
) => {
	switch (action.type) {
		case ADMIN_EMAIL_APPROVAL_REQUEST_PATCH:
			return {
				...state,
				loading: true,
				error: null,
			};
		case ADMIN_EMAIL_APPROVAL_RESPONSE_PATCH_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case ADMIN_EMAIL_APPROVAL_RESPONSE_PATCH_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};

		default:
			return state;
	}
};
export const emailValueReducer = (
	state = {
		emailValue: '',
	},
	action
) => {
	switch (action.type) {
		case SET_EMAIL_VALUE:
			return {
				...state,
				emailValue: action.payload,
			};
		default:
			return state;
	}
};
export const newPasswordReducer = (
	state = {
		newPassword: '',
	},
	action
) => {
	switch (action.type) {
		case SET_NEW_PASSWORD:
			return {
				...state,
				newPassword: action.payload,
			};
		default:
			return state;
	}
};
export const superAdminValueReducer = (
	state = {
		superAdminValue: '',
	},
	action
) => {
	switch (action.type) {
		case SET_IS_SUPER_ADMIN_VALUE:
			return {
				...state,
				superAdminValue: action.payload,
			};
		default:
			return state;
	}
};
